import { FC } from 'react';
import Flex from 'antd/es/flex';
import Text from 'antd/es/typography/Text';
import { MaterialDto } from '../ComparisonSheet.types';

interface MaterialRequestProps {
  value: MaterialDto;
}
export const MaterialRequestInfo: FC<MaterialRequestProps> = ({ value }) => {
  return (
    <Flex vertical style={{ maxWidth: '100%', whiteSpace: 'normal' }}>
      <Flex gap="small">
        <Text type="secondary">No.</Text>
        <Text strong>{value.code}</Text>
      </Flex>
      <Flex gap="small">
        <Text>{value.description}</Text>
      </Flex>
      <Flex gap="small">
        <Text type="secondary">Unit</Text>
        <Text strong>{value.unit}</Text>
      </Flex>
      <Flex gap="small">
        <Text type="secondary">Required Qty</Text>
        <Text strong>{value.requiredQty}</Text>
      </Flex>
    </Flex>
  );
};
export default MaterialRequestInfo;
